import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { products } from '../data/products';

export default function Products() {
  const { t } = useTranslation();
  const [search, setSearch] = useState('');
  const [selectedIds, setSelectedIds] = useState([]);
  const [compareOpen, setCompareOpen] = useState(false);

  const shown = useMemo(
    () => products.filter((p) => `${p.name} ${p.desc} ${(p.features || []).join(' ')}`.toLowerCase().includes(search.toLowerCase())),
    [search]
  );
  const selected = products.filter((p) => selectedIds.includes(p.id));

  const toggleCompare = (id) => {
    setSelectedIds((current) => {
      if (current.includes(id)) return current.filter((item) => item !== id);
      if (current.length >= 3) return current;
      return [...current, id];
    });
  };

  return (
    <div className="inner-page products-page">
      <section className="page-hero">
        <div className="site-container page-hero-content">
          <span className="eyebrow">{t('products.eyebrow', 'SAVDO UCHUN TEXNOLOGIYALAR')}</span>
          <h1>{t('products.heroTitle', 'Mahsulotlar')}</h1>
          <p>{t('products.heroSubtitle', 'Sifatli onlayn kassa texnikalari bilan biznesingizni yangi bosqichga olib chiqing.')}</p>
          <div className="breadcrumbs"><Link to="/">{t('navbar.home', 'Bosh sahifa')}</Link><span>/</span><span>{t('navbar.products', 'Mahsulotlar')}</span></div>
        </div>
      </section>

      <section className="section-block products-list-section">
        <div className="site-container">
          <div className="section-heading">
            <div><span className="eyebrow">{t('products.listEyebrow', 'KATALOG')}</span><h2>{t('products.listTitle', 'Mavjud mahsulotlar')}</h2></div>
            <label className="product-search"><span>⌕</span><input value={search} onChange={(e) => setSearch(e.target.value)} placeholder={t('products.searchPlaceholder', 'Mahsulotni qidirish...')} aria-label={t('products.searchPlaceholder', 'Mahsulotni qidirish...')} /></label>
          </div>

          <div className="compare-hint"><span className="compare-hint-icon">⇄</span><span>{t('products.compareHint', 'Mahsulotlarni taqqoslash uchun 2–3 ta modelni belgilang.')}</span><span className="compare-count">{selectedIds.length}/3</span></div>

          {shown.length ? (
            <div className="product-grid product-grid-all">
              {shown.map((item, index) => {
                const isSelected = selectedIds.includes(item.id);
                const limitReached = selectedIds.length >= 3 && !isSelected;
                return (
                  <article className={`product-card${isSelected ? ' product-card-selected' : ''}`} key={item.id}>
                    <div className="product-card-image">
                      <span className="product-number">{String(index + 1).padStart(2, '0')}</span>
                      <img src={item.img} alt={item.name} loading="lazy" />
                      <span className="product-arrow" aria-hidden="true">↗</span>
                      <button type="button" className={`compare-check${isSelected ? ' compare-check-active' : ''}`} onClick={() => toggleCompare(item.id)} disabled={limitReached} aria-pressed={isSelected} aria-label={`${isSelected ? 'Taqqoslashdan olib tashlash' : 'Taqqoslashga qo‘shish'}: ${item.name}`}>
                        <span>{isSelected ? '✓' : '+'}</span>{isSelected ? 'Tanlandi' : 'Taqqoslash'}
                      </button>
                    </div>
                    <div className="product-card-content">
                      <span className="product-category">{t('products.cardCategory', 'ONLAYN KASSA')}</span>
                      <h3>{item.name}</h3>
                      <p>{item.desc.length > 125 ? `${item.desc.slice(0, 125)}…` : item.desc}</p>
                      <div className="product-card-bottom"><strong>{item.price}</strong><Link to={`/Products/${item.id}`} className="product-detail-link">{t('products.viewDetails', 'Batafsil')} →</Link></div>
                    </div>
                  </article>
                );
              })}
            </div>
          ) : (
            <div className="empty-search"><span>⌕</span><h3>{t('products.noResults', 'Mahsulot topilmadi')}</h3><p>{t('products.tryAnother', 'Boshqa nom bilan qidirib ko‘ring.')}</p></div>
          )}

          <div className="catalog-note"><span className="catalog-note-icon">i</span><p>{t('products.priceNote', 'Narxlar va mavjudlik bo‘yicha aniq ma’lumot olish uchun biz bilan bog‘laning.')}</p><Link to="/Contact" className="text-link">{t('navbar.contact', 'Bog‘lanish')} ↗</Link></div>
        </div>
      </section>

      {selectedIds.length > 0 && (
        <aside className="compare-dock" aria-live="polite">
          <div className="compare-dock-copy"><span className="compare-dock-icon">⇄</span><span><strong>{selectedIds.length} ta mahsulot tanlandi</strong><small>{selectedIds.length < 2 ? 'Taqqoslash uchun yana bitta model tanlang' : 'Modellarni yonma-yon solishtiring'}</small></span></div>
          <div className="compare-dock-actions"><button type="button" className="compare-clear" onClick={() => setSelectedIds([])}>Tozalash</button><button type="button" className="compare-open" disabled={selectedIds.length < 2} onClick={() => setCompareOpen(true)}>Taqqoslash <span>→</span></button></div>
        </aside>
      )}

      {compareOpen && (
        <div className="compare-overlay" role="dialog" aria-modal="true" aria-labelledby="compare-title" onMouseDown={(e) => { if (e.target === e.currentTarget) setCompareOpen(false); }}>
          <section className="compare-modal">
            <div className="compare-modal-head"><div><span className="eyebrow">NAVOI ETM · SMART CHOICE</span><h2 id="compare-title">Mahsulotlarni taqqoslash</h2><p>Texnik xususiyatlarni yonma-yon ko‘rib chiqing.</p></div><button type="button" className="compare-modal-close" onClick={() => setCompareOpen(false)} aria-label="Yopish">×</button></div>
            <div className="compare-table-wrap"><table className="compare-table"><thead><tr><th>Texnik xususiyat</th>{selected.map((p) => <th key={p.id}><img src={p.img} alt="" /><strong>{p.name}</strong><span>{p.price}</span><Link to={`/Products/${p.id}`} onClick={() => setCompareOpen(false)}>Batafsil ↗</Link></th>)}</tr></thead><tbody>
              <tr><th>Model</th>{selected.map((p) => <td key={p.id}>{p.name}</td>)}</tr>
              <tr><th>Narxi</th>{selected.map((p) => <td key={p.id} className="compare-price">{p.price}</td>)}</tr>
              <tr><th>Kafolat</th>{selected.map((p) => <td key={p.id}>{p.warranty || 'Aniqlashtiring'}</td>)}</tr>
              <tr><th>Asosiy xususiyatlar</th>{selected.map((p) => <td key={p.id}><ul>{(p.features || []).slice(0, 6).map((feature, i) => <li key={`${p.id}-${i}`}>{feature}</li>)}</ul></td>)}</tr>
            </tbody></table></div>
            <div className="compare-modal-foot"><span>Mahsulot xususiyatlari ishlab chiqaruvchi ma’lumotlari asosida keltirilgan.</span><Link to="/Contact" className="button button-primary" onClick={() => setCompareOpen(false)}>Maslahat olish ↗</Link></div>
          </section>
        </div>
      )}
    </div>
  );
}
